import * as yup from 'yup'

const schema = yup.object().shape({
  email: yup
    .string()
    .email('E-mail deve ter um formato válido')
    .required('E-mail é obrigatório'),
})

export default schema
